<script setup>

const props = defineProps({
  albumInfo: {
    type: Object,
  },
	participants: {
    type: Array,
  }
})

</script>

<template>
	<div class="dark:text-light text-dark xl:text-lg mb-8 xl:mb-0">
		<NuxtImg class="mb-12" :src="albumInfo.image.url" />
		<Button :to="albumInfo.url" target class="mb-14">{{ $t('album.buy') }}</Button>

		<div v-if="albumInfo.released" class="py-4 border-b dark:border-light dark:border-opacity-30">
			{{ $t('album.published') }}: {{ useFormatDate(albumInfo.released) }}
		</div>
		<div v-if="albumInfo.genre?.attrs?.title" class="py-4 border-b dark:border-light dark:border-opacity-30">
			{{ $t('album.genre') }}: {{ albumInfo.genre.attrs.title }}
		</div>
		<div v-if="albumInfo.catnumber" class="py-4 border-b dark:border-light dark:border-opacity-30">
			{{ $t('album.catalog-number') }}: {{ albumInfo.catnumber }}
		</div>
		<div v-if="albumInfo.format" class="py-4 border-b dark:border-light dark:border-opacity-30">
			{{ $t('album.format') }}: {{ albumInfo.format }}
		</div>

		<div v-if="participants.length">
			<div v-for="(item, index) in participants" :key="index" class="mt-10 xl:mt-14">
				<h4 class="dark:text-light mb-4">{{ item.baserole }}</h4>
				<div
					v-for="(artist, index) in item.artists"
					:key="index"
					class="mb-4 pb-4"
					:class="{'border-b dark:border-light dark:border-opacity-30' : index + 1 !== item.artists.length}"
				>
					<p class="text-lg"><span v-if="artist.role">{{ artist.role }}:</span> <a class="link" :href="artist.url" target="_blank">{{ artist.name }}</a></p>
				</div>
			</div>
		</div>
	</div>
</template>